const themeSwitcher = (function () {
    function setTheme(themeName) {
        if (themeName === "dark") {
            document.documentElement.classList.add("dark");
            localStorage.setItem("dark-mode", "true");
            localStorage.removeItem("light-mode");
        } else if (themeName === "light") {
            document.documentElement.classList.remove("dark");
            localStorage.setItem("light-mode", "true");
            localStorage.removeItem("dark-mode");
        } else {
            localStorage.removeItem("dark-mode");
            localStorage.removeItem("light-mode");
            if (window.matchMedia("(prefers-color-scheme: dark)").matches) {
                document.documentElement.classList.add("dark");
            } else {
                document.documentElement.classList.remove("dark");
            }
        }
    }

    return {
        setTheme: setTheme,
    };
})();
export { themeSwitcher };
